import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { addDataMyFavoritAmiboAction } from "../Store/actions"
import '../css/Image.css'

export default function Card (props) {
  const {data} = props
  const history = useHistory()
  const dispatch = useDispatch()
  const dataMyFavoritAmibo = useSelector(state => state.myFavoritAmibo.dataMyFavoritAmibo)

  function getDetail () {
    history.push(`/detail/${data.tail}`);
  }
  function addToMyFavorit () {
    if(dataMyFavoritAmibo.length === 0) {
      dispatch(addDataMyFavoritAmiboAction({name: data.name, image: data.image, tail: data.tail}))
      history.push(`/myFavorite`);
    }
    else {
      let isFavorite = false
      for (let i = 0; i < dataMyFavoritAmibo.length; i++) {
        if(dataMyFavoritAmibo[i].tail === data.tail) {
          isFavorite = true
        }
      }
      if (isFavorite) {
        history.push(`/myFavorite`);
      } else {
        dispatch(addDataMyFavoritAmiboAction({name: data.name, image: data.image, tail: data.tail}))
        history.push(`/myFavorite`);
      }
    }
  }

  if(data) {
    return (
      <div className="col-3" style={{marginBottom: 8}}>
        <div className="card" style={{backgroundColor: "#e4fbff", border: "none"}}>
          <img className="imageLink" type="image" onClick={getDetail} name="Name of image button" src={data.image} alt="Mario" />
          <div className="card-body">
            <p className ="card-text" style={{fontWeight: "bold"}}>{data.name}</p>
            <button className="btn" style={{margin: 2, backgroundColor:"#f875aa", borderColor: "#ff9292"}} onClick={addToMyFavorit}>Add to My Favorite</button>
          </div>
        </div>
      </div>
    )
  } 
  else {
    return null
  }
}

